import { render } from "./SquircleComponent.vue?vue&type=template&id=d9326016&scoped=true"
import script from "./SquircleComponent.vue?vue&type=script&lang=js"
export * from "./SquircleComponent.vue?vue&type=script&lang=js"

import "./SquircleComponent.vue?vue&type=style&index=0&id=d9326016&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9326016"]])

export default __exports__